<template>
  <b-container fluid>
      <b-row>
        <b-col lg="12" sm="12">
          <iq-card>
            <template>
                <b-row>
                  <b-col lg="12" sm="12">
                    <b-row style="padding-left:5px">
                        <b-col xs="12" sm="12" md="2" class="text-right" style="margin-left: 82%; margin-top:8px">
                            <b-button variant="primary" @click="pdfExport">
                              {{  $t('globalTrans.export_pdf') }}
                            </b-button>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('globalTrans.year') }} : {{ $n(exam.year, {useGrouping: false}) }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark" >{{$t('globalTrans.organization')}} : {{ orgName(exam.org_id) }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark" >{{$t('educational_management.institute_type')}} : {{ getOfficeTypeName(exam.office_type_id) }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark" >{{ $t('educational_management.institute_name') }} : {{ getInstituteName(exam.office_id) }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('educational_management.class') }} : {{ getClassName(exam.class_id) }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="12" sm="12">
                        <div>
                          <b-table-simple striped bordered small>
                              <b-tr class="bg-primary">
                                <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                                <b-th>{{ $t('ds_exam_management.course_sub_curricular') }}</b-th>
                                <b-th>{{ $t('educational_management.exam_date') }}</b-th>
                                <b-th>{{ $t('educational_management.exam_start_time') }}</b-th>
                                <b-th>{{ $t('educational_management.exam_end_time') }}</b-th>
                              </b-tr>
                              <b-tr v-for="(item, index) in exam.details" :key="index">
                                <b-td>
                                    {{ $n(index + 1) }}
                                </b-td>
                                <b-td>
                                    {{ item.curricular_type_id ? getCurricularType(item.curricular_type_id) : getCourseName(item.course_id) }}
                                </b-td>
                                <b-td>
                                    {{ item.exam_date | dateFormat }}
                                </b-td>
                                <b-td>
                                    {{ EngBangNum(tConvert(item.exam_start_time)) }}
                                </b-td>
                                <b-td>
                                    {{ EngBangNum(tConvert(item.exam_end_time)) }}
                                </b-td>
                              </b-tr>
                          </b-table-simple>
                        </div>
                        <div class="row">
                            <div class="col-sm-3"></div>
                            <div class="col text-right">
                                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.close') }}</b-button>
                            </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
import ExportPdf from './export-routine-detail'
import { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
// import { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
export default {
  props: ['id'],
  created () {
    if (this.id) {
      const tmp = this.getExamInfoData()
      this.exam = tmp
    }
  },
  data () {
    return {
        exam: {
            fiscal_year_id: 0,
            org_id: 0,
            office_type_id: 0,
            office_id: 0,
            class_id: 0,
            exam_type_id: 0,
            details: []
        }
    }
  },
  computed: {
    localeLang () {
      return this.$i18n.locale
    }
  },
  methods: {
    getExamInfoData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return JSON.parse(JSON.stringify(tmpData))
    },
    EngBangNum (n) {
        if (this.$i18n.locale === 'bn') {
            return n.replace(/\d/g, d => '০১২৩৪৫৬৭৮৯'[d])
        } else {
            return n.replace(/[০-৯]/g, d => '০১২৩৪৫৬৭৮৯'.indexOf(d))
        }
    },
    tConvert (time) {
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]
      if (time.length > 1) {
        time = time.slice(1)
        time[5] = +time[0] < 12 ? ' ' + this.$t('ds_exam_management.am') : ' ' + this.$t('ds_exam_management.pm')
        time[0] = +time[0] % 12 || 12
      }
      return time.join('')
    },
    orgName (orgId) {
      const orgName = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId)
      if (this.$i18n.locale === 'bn') {
        return orgName.text_bn
      } else {
        return orgName.text_en
      }
    },
    getOfficeTypeName (typeId) {
      const TypeName = this.$store.state.commonObj.officeTypeList.find(item => item.value === typeId)
      if (this.$i18n.locale === 'bn') {
        return TypeName.text_bn
      } else {
        return TypeName.text
      }
    },
    getInstituteName (insId) {
      const obj = this.$store.state.commonObj.officeList.find(item => item.value === insId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
    getCurricularType (curTypeId) {
        const curricularName = this.$store.state.DisabilitySchoolService.commonObj.curricularTypeList.find(item => item.value === curTypeId)
        if (this.$i18n.locale === 'bn') {
            return curricularName.text_bn
        } else {
            return curricularName.text_en
        }
    },
    getCourseName (courseId) {
        const courseName = this.$store.state.DisabilitySchoolService.commonObj.courseNameList.find(item => item.value === parseInt(courseId))
        if (this.$i18n.locale === 'bn') {
            return courseName.text_bn
        } else {
            return courseName.text_en
        }
    },
    getClassName (classId) {
        const obj = this.$store.state.DisabilitySchoolService.commonObj.classList.find(item => item.value === classId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
    pdfExport () {
        const reportTitle = this.$t('ds_exam_management.exam_schedule')
        ExportPdf.exportPdfDetails(disabilitySchoolServiceBaseUrl, 'configuration/report-heading/detail', this.exam.org_id, reportTitle, this.exam, this)
    }
  }
}
</script>
